<!--
  @Description: 药品列表
  @Author: wang.y 
  @Date: 2023-08-17 
-->
<template>
  <div class="container">
    <h2>药品中心</h2>
    <h3>最新 • 真实 • 保障</h3>
    <div class="list">
      <div class="list-item" v-for="item,index in list" :key="index">
        <div class="list-item-img" @click="goDetail(item.id)">
          <img :src="item.cover_img" />
        </div>
        <div class="list-item-cnt">
          <p>{{item.title}}</p>
          <a class="btn" @click="goDetail(item.id)">查看详情</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getElderlyList } from '@/service'
export default {
  components: {},
  created() {
    this.getElderlyList()
  },
  mounted() {},
  data() {
    return {
      list: [],
    }
  },
  computed: {},
  methods: {
    async getElderlyList() {
      let res = await getElderlyList({
        page: 1,
        size: 999,
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'list', res.res)
      }
    },
    goDetail(row_id) {
      this.$router.push({ name: 'MedicineDetail', params: { id: row_id } })
    },
  },
}
</script>
<style lang='stylus' scoped>
.container
  width 1160px
  margin 40px auto
  color #333
  h3
    color #FA5A00
    font-weight normal
    margin-top 10px
  .list
    display grid
    grid-template-columns repeat(4, 1fr)
    grid-template-rows auto
    grid-gap 20px
    margin-top 20px
    &-item
      background #fff
      border 1px solid #f2f2f2
      transition all 0.3s linear
      &:hover
        box-shadow 0 15px 30px rgba(0, 0, 0, 0.1)
      &-img
        height 194px
        display flex
        justify-content center
        align-items center
        overflow hidden
        cursor pointer
        img
          max-width 100%
          max-height 100%
          transition all 0.3s linear
        &:hover
          img
            transform scale(1.1)
      &-cnt
        padding 20px
        p
          font-size 16px
          line-height 24px
          height 48px
          display -webkit-box
          overflow hidden
          text-overflow ellipsis
          word-break break-all
          -webkit-box-orient vertical
          -webkit-line-clamp 2
        .btn
          transition all 0.3s linear
          cursor pointer
          display block
          text-align center
          color #FA5A00
          border 1px solid #FA5A00
          line-height 38px
          border-radius 2px
          margin-top 15px
          &:hover
            color #fff
            background-color #FA5A00
</style>